import { Get, Set } from "../../../../../Request";

export const GetData = async (pageNumber, type, limit = 15) => {
  return await Get({
    url: "/withdraw/admin_list",
    data: {
      limit: limit,
      type: type,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};
export const SetDone = async data => {
  console.log(data);
  return await Set({
    url: data.role == "user" ? "/withdraw/user_done" : "/withdraw/done",
    data: {
      withdraw_id: data.withdraw_id,
      status: data.status,
      trackingCode: data.trackingCode,
      description: data.description,
    },
  }).then(data => {
    return data;
  });
};
